import {Badge, Card, CardBody, CardHeader, Col, ListGroup, ListGroupItem, Row} from "reactstrap";
import React, {Component, Fragment} from "react";
import {setFormFieldValue} from "../Applications/shared/shared";
import {deleteData, getData, postData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import "./store.css";
import {SafeImage} from "../../components/Shared/SafeImage";
import StoreItem from "./StoreItem";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";

export class Store extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      categories: [],
      products: [],
      totalResults: 0,
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 30,
      chosenProduct: null
    }
    this.category = 0;
  }

  componentDidMount() {
    EventClient.emit("NAV_MINIMIZE");
    this.getProducts();
  }

  componentWillUnmount() {

  }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  getProducts(category = "0") {
    var self = this;
    this.category = category;
    self.setState({showIndicator: true, activeTab: Number(category)});
    getData(`store/${category || "0"}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            categories: data.data.categories,
            products: data.data.products,
            dataLoaded: true,
          });
          window.scrollTo(0, 0)
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  addItem() {
    var self = this;
    self.setState({showIndicator: true});
    postData(`store/${this.category || "0"}/add`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({chosenProduct: data.data});
          window.scrollTo(0, 0)
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  needsPages() {
    return this.state.totalResults > this.state.limit;
  }

  maxPages() {
    return Math.ceil(this.state.totalResults / this.state.limit);
  }

  addCategory() {
    const category = prompt("Enter the category", "")
    if (!!category && category.length > 0) {
      const self = this;
      postData(`store/category/add`, {display: category}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            self.getProducts(this.category);
            window.scrollTo(0, 0)
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  editCategory(id) {
    const {display} = this.state.categories.find((cat) => String(cat.id) === String(this.category)) || {display: "N/A"}
    const category = prompt("Enter the category", display)
    if (!!category && category.length > 0 && category !== display) {
      const self = this;
      postData(`store/category/${id}`, {display: category}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            self.getProducts(this.category);
            window.scrollTo(0, 0)
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  removeCategory(id) {
    const {display} = this.state.categories.find((cat) => String(cat.id) === String(this.category)) || {display: "N/A"}
    const category = confirm(`Are you sure you want to remove category ${display}?`);
    if (!!category) {
      const self = this;
      deleteData(`store/category/${id}`, {}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            self.getProducts("0");
            window.scrollTo(0, 0)
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  render() {
    return (
      <Card>
        <CardHeader>
          Store

          <div className="card-actions">
            {hasPermission(RequiredPermission.StoreEdit) && (
              <Fragment>
                <button
                  onClick={() => this.addCategory()}
                  title={"Add Category"}
                  key={"addcategory"}
                  style={{padding: "0.50rem 0", height: 45}}
                >
                  <small className="text-muted">
                    <i className="cil-queue-add" style={{position: "relative", fontSize: 30}}></i>
                  </small>
                </button>
                {this.category !== "0" && (
                  <Fragment>
                    <button
                      onClick={() => this.editCategory(this.category)}
                      title={"Edit Category"}
                      key={"editcategory"}
                      style={{padding: "0.5rem 0", height: 45}}
                    >
                      <small className="text-muted">
                        <i className="fa fa-edit fa-lg" style={{position: "relative", fontSize: 30}}/>
                      </small>
                    </button>
                    <button
                      onClick={() => this.addItem()}
                      title={"Add Product"}
                      key={"addproduct"}
                      style={{padding: "0.5rem 0", height: 45}}
                    >
                      <small className="text-muted">
                        <i className="fa fa-plus fa-lg" style={{position: "relative", fontSize: 30}}/>
                      </small>
                    </button>
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>

        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="12" md="3" className="mb-4">
              <ListGroup>
                <ListGroupItem active={this.state.activeTab === 0}
                               onClick={() => {
                                 this.getProducts('0');
                               }}
                               style={{cursor: "pointer", padding: "0.25rem 1.25rem"}}
                >Featured</ListGroupItem>
                {this.state.categories && this.state.categories.map((cat) => {
                  return (
                    <ListGroupItem active={this.state.activeTab === cat.id}
                                   key={cat.id}
                                   onClick={() => {
                                     this.getProducts(cat.id);
                                   }}
                                   style={{cursor: "pointer", padding: "0.25rem 1.25rem"}}
                    >{cat.display}&nbsp;<Badge pill color="success">{cat.counted}</Badge></ListGroupItem>
                  )
                })}
              </ListGroup>
            </Col>
            <Col xs="12" md="9" className="mb-4">
              <div style={{width: "100%", display: "flex", flexWrap: "wrap"}}>
                {(!this.state.products || this.state.products.length === 0) && (
                  <div>No Products
                    {this.category !== "0" && hasPermission(RequiredPermission.StoreRemove) && (
                      <small className="text-muted"><br/><br/> Add products or&nbsp;
                        <span onClick={() => this.removeCategory(this.category)}
                              style={{cursor: "pointer"}}>Remove this category</span>
                      </small>
                    )}
                  </div>
                )}
                {this.state.products && this.state.products.map((product) => {
                  // if (product.id === 6 && !this.state.chosenProduct) {
                  //   this.setState({chosenProduct: product});
                  // }
                  return <div key={product.id}
                              onClick={() => this.setState({chosenProduct: product})}
                              className={"store-item"}>
                    <div>
                      <SafeImage src={product.url} width={175} height={"auto"}/>
                      <span>{product.title}</span>
                    </div>
                  </div>
                })}
              </div>
            </Col>
          </Row>
        </CardBody>
        {this.state.chosenProduct && (
          <StoreItem product={this.state.chosenProduct}
                     onClose={() => this.setState({chosenProduct: null})}
                     categories={this.state.categories}
                     onUpdate={() => {
                       this.getProducts(this.category);
                     }}
          />
        )}
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Store/Store.js